export default __webpack_public_path__ + "static/media/wIcon.f6f46ed2.webp";